import axios from 'axios';

export function getAreas() {
    return axios({
        method: 'GET',
        url: '/api/v1/ports/areas',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getArea(areaId) {
    return axios({
        method: 'GET',
        url: '/api/v1/ports/areas/' + areaId,
        withCredentials: true,
    })
        .then(response => response.data);
}

export function updateArea(item) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/areas/${item._id}`,
        withCredentials: true,
        data: {
            ...item,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function transformAreaToPort(id, data) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/areas/${id}/transform`,
        withCredentials: true,
        data,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function updateAreaAlt(item) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/${item._id}/alt`,
        data: {
            alt: item.alt,
        },
        withCredentials: true,
    })
        .then(response => ({
            ...response.data,
            item,
        }))// todo sending response.response
        .catch(response => ({
            ...response.response.data,
            item,
        }));
}

export function deleteArea(item) {
    return axios({
        method: 'delete',
        url: `/api/v1/ports/areas/${item._id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function createArea(item) {
    return axios({
        method: 'post',
        url: '/api/v1/ports/areas/',
        withCredentials: true,
        data: {
            ...item,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function mergeAreaToArea(areaId, mergeId) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/areas/${areaId}/merge`,
        withCredentials: true,
        data: {
            mergeId,
        },
    });
}

export function joinAreaToArea(mergeId, areaId) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/areas/${areaId}/join`,
        withCredentials: true,
        data: {
            mergeId,
        },
    });
}

export function getAreaRelations(areaId) {
    return axios({
        method: 'GET',
        url: `/api/v1/ports/areas/${areaId}?withTree=true`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function addAreaToArea(areaParentId, areaToAdd) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/areas/${areaParentId}`,
        withCredentials: true,
        data: {
            ...areaToAdd,
            recalculateChildPorts: true,
        },
    });
}

/** @param {[number, number]} lnglat Longitude, latitude */
export function getAreasAtPoint(lnglat) {
    return axios({
        method: 'GET',
        url: `/api/v2/areas-at-point/${lnglat[0]}/${lnglat[1]}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/regions/areas.js